import { formLabelBaseStyle } from '../../form/form/styles';
export const FormLabel = {
    variants: {
        primary: formLabelBaseStyle
    },
    defaultProps: {
        variant: 'primary'
    }
};
